import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import './ArtigoDetalhes.css';

function ArtigoDetalhes() {
  const { id } = useParams();
  const [artigo, setArtigo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchArtigo = async () => {
      try {
        const response = await fetch(`${apiUrl}/artigos/${id}`);

        if (!response.ok) {
          throw new Error('Erro ao buscar o artigo');
        }
        const data = await response.json();
        setArtigo(data);
      } catch (error) {
        setError(error.message);
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchArtigo();
  }, [id]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" mt={4}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Container maxWidth="md">
        <Alert severity="error" sx={{ mt: 4 }}>
          Erro: {error}
        </Alert>
      </Container>
    );
  }

  if (!artigo) {
    return (
      <Container maxWidth="md">
        <Alert severity="warning" sx={{ mt: 4 }}>
          Artigo não encontrado.
        </Alert>
      </Container>
    );
  }

  const handleDownload = () => {
    if (artigo.arquivoDownload) {
      const link = document.createElement('a');
      link.href = artigo.arquivoDownload;
      link.download = artigo.arquivoDownload.split('/').pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      alert('Arquivo PDF não disponível');
    }
  };

  return (
    <div className="artigo-background">
      <Container maxWidth="lg">
        <hr style={{ margin: '40px 0', borderTop: '1px solid #ddd' }} />
        <hr style={{ margin: '40px 0', borderTop: '1px solid #ddd' }} />
        <Paper elevation={3} sx={{ padding: 4, mt: 4, borderRadius: 2 }}>
          {/* Cabeçalho com imagem */}

          <Typography
              variant="h2"
              align="center"
              gutterBottom
              style={{
                fontFamily: "'Lato', serif",
                color: "#800020",
                textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
                borderBottom: "4px solid #d4af37",
                paddingBottom: "10px",
                textTransform: "uppercase",
                animation: "glow 2s infinite alternate",
                marginTop: "7%"  // Aqui é onde você define o espaço superior
              }}
            >     {artigo.titulo}
          </Typography>
           
          <Box display="flex" justifyContent="center" my={3}>
            <img
              src={artigo.imagens[0]}
              
              className="artigo-imagem"
            />
          </Box>

          <Typography
  variant="body1"
  component="div"
  sx={{ lineHeight: 1.8, textAlign: 'justify' }}
  dangerouslySetInnerHTML={{
    __html: artigo.conteudo.replace(/<img [^>]*>/g, (match) =>
      match
        .replace(/(width|height)="[^"]*"/g, '') // Remove width/height inline
        .replace('<img', '<img style="max-width:100%;height:auto;display:block;margin:0 auto;"') // Adiciona estilo inline
    )
  }}
/>



          <Typography variant="caption" display="block" sx={{ mt: 2, fontStyle: 'italic', textAlign: 'right', color: 'gray' }}>
            Publicado em: {new Date(artigo.dataCriacao).toLocaleDateString('pt-BR')}
          </Typography>

          {artigo.arquivoDownload && (
            <Box textAlign="center" mt={4}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleDownload}
                sx={{
                  fontWeight: 'bold',
                  textTransform: 'none',
                  borderRadius: '25px',
                  backgroundColor: '#d4af37',  // Cor de fundo amarela
                  padding: '12px 24px',         // Aumenta o tamanho do botão (altura e largura)
                  fontSize: '18px',             // Aumenta o tamanho da fonte
                  '&:hover': {
                    backgroundColor: '#800020',  // Cor de fundo ao passar o mouse
                    transform: 'scale(1.1)',      // Aumenta mais o botão ao passar o mouse
                    transition: 'transform 0.3s ease, background-color 0.3s ease', // Efeito suave
                  },
                }}
              >
                Baixar PDF
              </Button>
            </Box>


          )}
        </Paper>
      </Container>
    </div>
  );
}

export default ArtigoDetalhes;
